<div class="main">
   <div class="container-fluid">
      <div id="files">
         <div class="box-title">
            <h5 class="fw-bold">
               {{ "DCO.Pages_clientfileconfiguration" | translate }}
            </h5>
            <p class="text-muted">{{ "DCO.Pages_clientfileconfiguration_PageDescription" | translate }}</p>
         </div>
         <div class="card">
            <div class="card-body">
               <div class="row">
                  <div class="col-12 px-4">
                     <!-- Formulario de búsqueda -->
                     <form class="d-flex flex-wrap">
                        <!--La caja desplegable con los document type-->
                        <div class="mb-3 me-3 flex-fill">
                           <label for="documentType" class="fw-semibold form-label mb-1">
                              {{ "DCO.FileConfiguration_DocumentType" | translate }}
                           </label>
                           <div>
                              <select id="documentType" name="documentType" class="form-select">
                                 <option [value]="null">
                                    {{
                                    "DCO.ClientFileConfiguration_SelectADocumentType" | translate
                                    }}
                                 </option>
                                 <option *ngFor="let documentType of this.documentTypeList" [value]="documentType">
                                    <span *ngIf="documentType === 'GENERAL_CONDITIONS'">
                                       {{"DCO.ClientFileConfiguration_GeneralConditions"| translate}}
                                    </span>
                                    <span *ngIf="documentType === 'CANCELLATION_POLICY'">
                                       {{"DCO.ClientFileConfiguration_CancellationPolicy"| translate}}
                                    </span>
                                    <span *ngIf="documentType === 'DENIAL_POLICY'">
                                       {{"DCO.ClientFileConfiguration_DenialPolicy"| translate}}
                                    </span>
                                    <span *ngIf="documentType === 'OTHER_DOCUMENTS'">
                                       {{"DCO.ClientFileConfiguration_OtherDocuments"| translate}}
                                    </span>
                                 </option>

                              </select>
                           </div>
                        </div>
                        <div class="mb-3 me-3 flex-fill">
                           <!--La caja desplegable con los comercios-->
                           <label for="comerceType" class="fw-semibold form-label mb-1">
                              {{ "CMP.ContactType_Commerce" | translate }}
                           </label>
                           <div>
                              <select id="comerceType" name="comerceType" class="form-select">
                                 <option [value]="null">{{ "DCO.FileConfiguration_MerchantSelection" | translate }}
                                 </option>
                                 <option [value]="contact.contactIdGuid" *ngFor="let contact of contacts">
                                    {{contact.commerceNumber}}
                                    -
                                    {{contact.commerceName}}</option>
                              </select>
                           </div>
                        </div>
                        <div class="my-3 me-3 flex-fill">
                           <button class="btn btn-outline-primary fw-semibold text-sm mt-2" id="buttonout"
                              (click)="Search()">
                              <i class="fa-solid fa-magnifying-glass"></i>
                              {{"DCO.ClaimsClient_Search" | translate}}
                           </button>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
         <!-- Fin contenedor buscador -->
         <!-- Contenedor con botón de Añadir y tabla repositorio -->
         <div class="card">
            <div class="card-body">
               <div class="row">
                  <div class="col-12">
                     <div class="clearfix">
                        <div class="float-end py-2">
                           <button type="button" class="btn btn-primary fw-semibold text-sm" (click)="openAddModal()"><i
                                 class="fa-solid fa-arrow-up-from-bracket fa-lg me-2"></i>
                              {{"DCO.ClientFileConfiguration_AddFiles" | translate}}
                           </button>
                        </div>
                     </div>
                     <div class="row">
                        <div class="table-responsive mx-0 px-0">
                           <table class="table table-hover order-table">
                              <thead>
                                 <tr>
                                    <th>&nbsp;</th>
                                    <th class="text-center">{{"DCO.ClaimsClient_Edit" | translate}}</th>
                                    <th>{{"DCO.ClientFileConfiguration_Type" | translate}}</th>
                                    <th>{{"DCO.ClientFileConfiguration_Description" | translate}}</th>
                                    <th>{{"DCO.ClientFileConfiguration_ConfigurationDate" | translate}}</th>
                                    <th class="text-center">{{"DCO.ClientFileConfiguration_FileHistory" | translate}}
                                    </th>
                                    <th class="text-center">{{"DCO.Attachment_Download" | translate}}</th>
                                    <th class="text-center">{{"DCO.ClientFileConfiguration_ChangeFile" | translate}}
                                    </th>
                                    <th class="text-center">{{"DCO.ClaimsClient_Delete" | translate}}</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <ng-container *ngFor="let commerceFile of commerceFileList; let i = index">
                                    <tr>
                                       <td>
                                          <button class="btn btn-link" (click)="toggleCollapse(i)"><i
                                                class="fa-solid fa-angle-down fa-lg"
                                                title="{{'DCO.ClaimsClient_Expand' | translate}}"></i>
                                          </button>
                                       </td>
                                       <td class="text-center"><button type="button" class="btn btn-link"
                                             (click)="openEditModal(commerceFile)"><i
                                                class="fa-regular fa-pen-to-square fa-lg text-primary"
                                                title="{{'DCO.ClaimsClient_Edit' | translate}}"></i></button>
                                       </td>
                                       <td class="fw-semibold">
                                          <span *ngIf="commerceFile.documentType === documentType.CANCELLATION_POLICY">
                                             {{"DCO.ClientFileConfiguration_CancellationPolicy" | translate}}
                                          </span>
                                          <span *ngIf="commerceFile.documentType === documentType.GENERAL_CONDITIONS">
                                             {{"DCO.ClientFileConfiguration_GeneralConditions" | translate}}
                                          </span>
                                          <span *ngIf="commerceFile.documentType === documentType.DENIAL_POLICY">
                                             {{"DCO.ClientFileConfiguration_DenialPolicy" | translate}}
                                          </span>
                                          <span *ngIf="commerceFile.documentType === documentType.OTHER_DOCUMENTS">
                                             {{"DCO.ClientFileConfiguration_OtherDocuments" | translate}}
                                          </span>
                                       </td>
                                       <td>{{commerceFile.description}}</td>
                                       <td>{{ commerceFile.created | date:'yyyy-MM-dd' }}</td>
                                       <td class="text-center"><button type="button" data-bs-toggle="modal"
                                             data-bs-target="#statickBackdrop4" class="btn btn-link"><i
                                                class="fa-solid fa-clock-rotate-left fa-lg text-primary"
                                                (click)="versiones(commerceFile.commerceFileId, commerceFile.description, commerceFile.documentType)"
                                                title="{{'DCO.ClientFileConfiguration_FileHistory' | translate}}"></i></button>
                                       </td>
                                       <td class="text-center">
                                          <button type="button" class="btn btn-link"
                                             (click)="downloadFile(commerceFile.commerceFileId)">
                                             <i class="fa-solid fa-download fa-lg text-primary"
                                                title="{{'DCO.Attachment_Download' | translate}}"></i>
                                             <!--{{"DCO.ClientFileConfiguration_DownloadFile" | translate}}-->
                                             <DCO-download-file style="display: none;"></DCO-download-file>
                                          </button>
                                       </td>
                                       <td class="text-center">
                                          <button type="button" class="btn btn-link"
                                             (click)="openChangeModal(commerceFile.commerceFileId)">
                                             <i class="fa-solid fa-arrows-rotate fa-lg text-primary"
                                                title="{{'DCO.ClientFileConfiguration_ChangeFile' | translate}}"></i><!--{{"DCO.ClientFileConfiguration_ChangeFile" | translate}}-->
                                          </button>
                                       </td>
                                       <td class="text-center">
                                          <button type="button" class="btn btn-link">
                                             <i class="fa-regular fa-trash-can fa-lg text-danger"
                                                (click)="delete(commerceFile.commerceFileId)"
                                                title="{{'DCO.ClaimsClient_Delete' | translate}}"></i>
                                          </button>
                                       </td>
                                    </tr>
                                    <tr *ngIf="expandedItemIndex === i">
                                       <td class="text-end pe-1">
                                          <button type="button" class="btn btn-link"><i
                                                class="fa-regular fa-trash-can fa-lg text-danger"
                                                (click)="delete(commerceFile.commerceFileId)"
                                                title="{{'DCO.ClaimsClient_Delete' | translate}}"></i>
                                          </button>
                                       </td>
                                       <td colspan="8">
                                          <span class="badge bg-primary px-2 py-1 me-3 fs-md fw-normal"
                                             *ngFor="let contacts of commerceFile.contacts">
                                             {{ contacts.commerceNumber }} - {{ contacts.commerceName }}
                                          </span>
                                       </td>
                                    </tr>
                                 </ng-container>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- VENTANAS Modales-->
<!--1)Ventana modal Cambiar archivo-->
<div class="modal fade" id="statickBackdrop5" data-bs-backdrop="static" data-bs-keyboard="false">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title mb-0"><i class="fa-solid fa-arrows-rotate me-2"></i>
               {{ "DCO.ClientFileConfiguration_ChangeFile" | translate }}
            </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cancelar"></button>
         </div>
         <div class="modal-body">
            <h6>{{
               "DCO.DCO.ComponentFileUpload_File" | translate
               }}</h6>
            <!--boton que abre el escritorio-->
            <label for="Añadir Fichero" class="btn btn-primary">{{
               "DCO.ClientFileConfiguration_AddFile" | translate
               }}</label>
            <input class="btn btn-primary" data-bs-toggle="popover" title="Popover" type="file" id="Añadir Fichero"
               class="fichero" />
            <p>
               {{
               "DCO.ComponentFileUpload_Extensions" | translate
               }}:"jpeg,jpg,gif,doc,docx,rtf,txt,xls,xlsx,pdf,xml,odt,oxs".
            </p>
         </div>
         <div class="modal-footer">
            <button type="button" data-bs-dismiss="modal" class="btn btn-outline-danger">
               {{ "DCO.MassiveInformation_Cancel" | translate }}
            </button>
            <button type="button" class="btn btn-primary">
               {{ "DCO.MassiveInformation_Accept" | translate }}
            </button>
         </div>
      </div>
   </div>
</div>

<!--2)Ventana Modal Editar fichero dentro del boton lapiz-->
<div class="modal fade" #editModal id="editModal" data-bs-backdrop="static" data-bs-keyboard="false">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title mb-0"><i
                  class="fa-regular fa-pen-to-square me-2"></i>{{"DCO.ClientfileConfiguration_EditFile" | translate}}
            </h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal();"
               aria-label="Cancelar"></button>
         </div>
         <div class="modal-body" *ngIf="editFile">
            <form>
               <div class="d-flex flex-column mb-4">
                  <label for="tipologia" class="fw-semibold mb-1">{{"DCO.ClientFileConfiguration_Type" |
                     translate}}</label>
                  <div>
                     <select name="tipologia" id="tipologia" class="form-select" [(ngModel)]="editFile.documentType"
                        disabled>
                        <option [ngValue]="documentType.GENERAL_CONDITIONS">
                           {{"DCO.ClientFileConfiguration_GeneralConditions" | translate}}
                        </option>
                        <option [ngValue]="documentType.CANCELLATION_POLICY">
                           {{"DCO.ClientFileConfiguration_CancellationPolicy" | translate}}
                        </option>
                        <option [ngValue]="documentType.DENIAL_POLICY">
                           {{"DCO.ClientFileConfiguration_DenialPolicy" | translate}}
                        </option>
                        <option [ngValue]="documentType.OTHER_DOCUMENTS">
                           {{"DCO.ClientFileConfiguration_OtherDocuments" | translate}}
                        </option>
                     </select>
                  </div>
               </div>
               <div class="d-flex flex-column mb-4">
                  <label for="description" class="fw-semibold mb-1">{{"DCO.ClientFileConfiguration_Description"
                     |
                     translate}}</label>
                  <div>
                     <input name="description" id="description" class="form-control" [(ngModel)]="editFile.description">
                  </div>
               </div>
               <!-- Listado de contactos -->
               <div class="mb-4">
                  <p class="fw-semibold mb-2">{{ "DCO.Enrollment_AvailableCommerceList" | translate }}<span
                        class="text-sm ms-1">*</span></p>
                  <p class="text-muted text-sm mb-2 fst-italic">
                     {{"DCO.ClientFileConfiguration_SelectMerchantsAddFile" |
                     translate}}</p>
                  <DCO-contacts-list name="contactList" [contacts]="contacts" [checkboxes]="true"
                     (selectedContactsChange)="onEditContactsSelected($event)">
                  </DCO-contacts-list>
               </div>
            </form>
         </div>
         <div class="modal-footer text-end">
            <button type="button" data-bs-dismiss="modal"
               class="btn btn-outline-primary">{{"DCO.MassiveInformation_Cancel" | translate}}</button>
            <button type="button" class="btn btn-primary" (click)="update()">{{"DCO.MassiveInformation_Accept"
               |
               translate}}</button>
         </div>
      </div>
   </div>
</div>
<!--3)La ventana modal boton-Reloj-->
<div class="modal fade" id="statickBackdrop4" data-bs-backdrop="static" data-bs-keyboard="false">
   <div class="modal-dialog modal-lg">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title mb-0">
               <i class="fa-solid fa-clock-rotate-left me-2"></i>{{ "DCO.ClientFileConfiguration_FileHistory" |
               translate }}
            </h6>
            <button type="button" class="btn-close" (click)="closeModal();" aria-label="Cancelar"></button>
         </div>
         <div class="modal-body">
            <div>
               <p class="mb-1"><span class="me-2 fw-semibold">{{
                     "DCO.ClientFileConfiguration_Description" | translate
                     }}</span>{{ this.descriptionVersion }}
               </p>
               <p class="mb-3"><span class="me-2 fw-semibold">{{ "DCO.ClientFileConfiguration_Type" | translate
                     }}</span>{{ this.documentTypeVersion | translate }}
               </p>
            </div>
            <!--Tabla de la ventana modal-->
            <div class="table-responsive mx-0 px-0">
               <table class="table table-hover order-table">
                  <thead>
                     <tr>
                        <th>{{ "DCO.ClientFileConfiguration_RegistrationDate" | translate }}</th>
                        <th>{{ "DCO.ComponentFileUpload_File" | translate }}</th>
                        <th class="text-center">{{"DCO.Attachment_Download" | translate}}</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr *ngFor="let version of commerceFileVersions">
                        <td>{{ version.created | date : "yyyy-MM-dd" }}</td>
                        <td>{{ version.fileName }}</td>
                        <td class="text-center"><DCO-download-file
                              [fileId]="version.commerceFileHistoricID"></DCO-download-file></td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <div class="modal-footer text-end">
            <button type="button" data-bs-dismiss="modal" class="btn btn-outline-primary">
               {{ "DCO.MassiveInformation_Cancel" | translate }}
            </button>
         </div>
      </div>
   </div>
</div>

<!--5)Ventana modal Añadir Ficheros-->
<div class="modal fade" #addFileModal id="addFileModal" data-bs-backdrop="static" data-bs-keyboard="false">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title mb-0"><i
                  class="fa-solid fa-arrow-up-from-bracket me-2"></i>{{"DCO.ClientFileConfiguration_AddFiles" |
               translate}}</h6>
            <button type="button" class="btn-close" (click)="closeModal();" aria-label="Cancelar"></button>
         </div>
         <div class="modal-body">
            <form>
               <div class="d-flex flex-column mb-4">
                  <label for="tipologia" class="fw-semibold mb-1">{{"DCO.ClientFileConfiguration_Type" |
                     translate}}<span class="text-sm ms-1">*</span></label>
                  <div>
                     <select id="tipologia" name="tipologia" class="form-select"
                        [(ngModel)]="this.commerceFileCreate.documentType">
                        <option [ngValue]="null"><span
                              class="fst-italic text-muted">{{"DCO.ClientFileConfiguration_SelectADocumentType"
                              |
                              translate}}</span>
                        </option>
                        <option [ngValue]="documentType.GENERAL_CONDITIONS">
                           {{"DCO.ClientFileConfiguration_GeneralConditions" | translate}}</option>
                        <option [ngValue]="documentType.CANCELLATION_POLICY">
                           {{"DCO.ClientFileConfiguration_CancellationPolicy" | translate}}</option>
                        <option [ngValue]="documentType.DENIAL_POLICY">
                           {{"DCO.ClientFileConfiguration_DenialPolicy" |
                           translate}}</option>
                        <option [ngValue]="documentType.OTHER_DOCUMENTS">
                           {{"DCO.ClientFileConfiguration_OtherDocuments" |
                           translate}}</option>
                     </select>
                  </div>
               </div>
               <div class="d-flex flex-column mb-4">
                  <label id="file-upload" class="fw-semibold mb-1">{{"DCO.ComponentFileUpload_File" |
                     translate}}<span class="text-sm ms-1">*</span></label>
                  <DCO-file-upload (fileSelected)="onFileSelected($event)"></DCO-file-upload>
                  <p class="text-muted text-sm mt-2 fst-italic">{{ "DCO.Enrollment_DocumentUploadInfo" |
                     translate
                     }}<!-- Formatos permitidos: .pdf, .docx, .doc, .jpg, .jpeg, .png | Tamaño máximo: 10MB -->
                  </p>
               </div>
               <div class="d-flex flex-column mb-4">
                  <label for="description" class="fw-semibold mb-1">{{"DCO.ClientFileConfiguration_Description"
                     |
                     translate}}</label>
                  <div>
                     <input id="description" [(ngModel)]="this.commerceFileCreate.description" class="form-control"
                        name="Prueba fichero">
                  </div>
               </div>
               <div class="mb-4">
                  <p class="fw-semibold mb-2">{{ "DCO.Enrollment_AvailableCommerceList" | translate }}<span
                        class="text-sm ms-1">*</span></p>
                  <p class="text-muted text-sm mb-2 fst-italic">
                     {{"DCO.ClientFileConfiguration_SelectMerchantsAddFile" |
                     translate}}</p>
                  <div class="mb-2">
                     <label class="btn btn-primary text-sm fw-semibold d-inline-flex align-items-center">
                        <input type="checkbox" id="all-commerces" name="all-commerces" class="form-check-input m-0"
                           [(ngModel)]="isAllSelected" (change)="toggleSelectAll()" />
                        <span class="ms-2">{{ "DCO.Enrollment_ALL" | translate }}</span>
                     </label>
                  </div>
                  <DCO-contacts-list [contacts]="contacts" [checkboxes]="true"
                     (selectedContactsChange)="onContactsSelected($event)">
                  </DCO-contacts-list>
               </div>
            </form>
         </div>
         <div class="modal-footer text-end">
            <button type="button" class="btn btn-outline-primary" (click)="closeModal()">
               {{ "DCO.MassiveInformation_Cancel" | translate }}
            </button>
            <button type="button" class="btn btn-primary" (click)="addFile()">
               {{ "DCO.MassiveInformation_Accept" | translate }}
            </button>
         </div>
      </div>
   </div>
</div>


<!--6)Ventana modal Cambiar Ficheros-->
<div class="modal fade" #changeFileModal id="changeFileModal" data-bs-backdrop="static" data-bs-keyboard="false">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title mb-0"><i
                  class="fa-solid fa-arrows-rotate me-2"></i>{{"DCO.ClientFileConfiguration_ChangeFile" | translate}}
            </h6>
            <!--Aqui iría el boton deslizante-->
            <button type="button" class="btn-close" (click)="closeModal();" aria-label="Cancelar"></button>
         </div>
         <div class="modal-body">
            <form>
               <div class="mb-3">
                  <DCO-file-upload (fileSelected)="onFileSelected($event)"></DCO-file-upload>
                  <p class="text-muted text-sm mt-2 fst-italic">{{ "DCO.Enrollment_DocumentUploadInfo" |
                     translate
                     }}<!-- Formatos permitidos: .pdf, .docx, .doc, .jpg, .jpeg, .png | Tamaño máximo: 10MB -->
                  </p>
               </div>
            </form>
         </div>
         <div class="modal-footer text-end">
            <button type="button" class="btn btn-outline-primary"
               (click)="closeModal();">{{"DCO.MassiveInformation_Cancel" | translate}}</button>
            <button type="button" class="btn btn-primary"
               (click)="commerceFileRequest(selectedCommerceFileId)">{{"DCO.MassiveInformation_Accept"
               |
               translate}}</button>
         </div>
      </div>
   </div>
</div>

<!-- Modal de info -->
<div class="modal fade" #successModal id="successModal" tabindex="-1" aria-labelledby="successModalLabel"
   aria-hidden="true">
   <div class="modal-dialog">
      <div class="modal-content">
         <div class="modal-header">
            <h6 class="modal-title mb-0" id="successModalLabel"><i
                  class="fa-solid fa-circle-info me-2"></i>{{"DCO.ClaimsClientDocumentation_Information"
               |
               translate}}
            </h6>
            <button type="button" class="btn-close" (click)="closeModal();" aria-label="Cerrar"></button>
         </div>
         <div class="modal-body">
            <p>{{ successMessage }}</p>
         </div>
         <div class="modal-footer text-end">
            <button type="button" class="btn btn-primary" (click)="closeModal();">{{"DCO.MassiveInformation_Accept" |
               translate}}</button>
         </div>
      </div>
   </div>
</div>